import byteSize from 'byte-size';

/**
 * @param file File
 * @returns ${size} kb | mb
 */
export const getInlineFileSizeText = (file: File): string => {
  return byteSize(file.size).toString();
};
